 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTHUNT_9781401684952_EPUB_C0_R1 from '@/components/Text/Hunt_9781401684952_epub_c0_r1'
 import TEXTHUNT_9781401684952_EPUB_C3_R1 from '@/components/Text/Hunt_9781401684952_epub_c3_r1'
 import TEXTHUNT_9781401684952_EPUB_C4_R1 from '@/components/Text/Hunt_9781401684952_epub_c4_r1'
 import TEXTHUNT_9781401684952_EPUB_C16_R1 from '@/components/Text/Hunt_9781401684952_epub_c16_r1'
 import TEXTHUNT_9781401684952_EPUB_C17_R1 from '@/components/Text/Hunt_9781401684952_epub_c17_r1'
 import TEXTHUNT_9781401684952_EPUB_C65_R1 from '@/components/Text/Hunt_9781401684952_epub_c65_r1'
 import TEXTHUNT_9781401684952_EPUB_C52_R1 from '@/components/Text/Hunt_9781401684952_epub_c52_r1'
 import TEXTHUNT_9781401684952_EPUB_C53_R1 from '@/components/Text/Hunt_9781401684952_epub_c53_r1'
 import TEXTHUNT_9781401684952_EPUB_C54_R1 from '@/components/Text/Hunt_9781401684952_epub_c54_r1'
 import TEXTHUNT_9781401684952_EPUB_C55_R1 from '@/components/Text/Hunt_9781401684952_epub_c55_r1'
 import TEXTHUNT_9781401684952_EPUB_C56_R1 from '@/components/Text/Hunt_9781401684952_epub_c56_r1'
 import TEXTHUNT_9781401684952_EPUB_C57_R1 from '@/components/Text/Hunt_9781401684952_epub_c57_r1'
 import TEXTHUNT_9781401684952_EPUB_C58_R1 from '@/components/Text/Hunt_9781401684952_epub_c58_r1'
 import TEXTHUNT_9781401684952_EPUB_C59_R1 from '@/components/Text/Hunt_9781401684952_epub_c59_r1'
 import TEXTHUNT_9781401684952_EPUB_C60_R1 from '@/components/Text/Hunt_9781401684952_epub_c60_r1'
 import TEXTHUNT_9781401684952_EPUB_C61_R1 from '@/components/Text/Hunt_9781401684952_epub_c61_r1'
 import TEXTHUNT_9781401684952_EPUB_C62_R1 from '@/components/Text/Hunt_9781401684952_epub_c62_r1'
 import TEXTHUNT_9781401684952_EPUB_C63_R1 from '@/components/Text/Hunt_9781401684952_epub_c63_r1'
 import TEXTHUNT_9781401684952_EPUB_C64_R1 from '@/components/Text/Hunt_9781401684952_epub_c64_r1'
 import TEXTHUNT_9781401684952_EPUB_C67_R1 from '@/components/Text/Hunt_9781401684952_epub_c67_r1'
 import TEXTHUNT_9781401684952_EPUB_C66_R1 from '@/components/Text/Hunt_9781401684952_epub_c66_r1'
 import TEXTSECTION0002 from '@/components/Text/Section0002'
 import TEXTSECTION0001 from '@/components/Text/Section0001'
 import TEXTHUNT_9781401684952_EPUB_C2_R1 from '@/components/Text/Hunt_9781401684952_epub_c2_r1'
 import TEXTHUNT_9781401684952_EPUB_C68_R1 from '@/components/Text/Hunt_9781401684952_epub_c68_r1'
 import TEXTHUNT_9781401684952_EPUB_C69_R1 from '@/components/Text/Hunt_9781401684952_epub_c69_r1'
 import TEXTHUNT_9781401684952_EPUB_C70_R1 from '@/components/Text/Hunt_9781401684952_epub_c70_r1'
 import TEXTHUNT_9781401684952_EPUB_C75_R1 from '@/components/Text/Hunt_9781401684952_epub_c75_r1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Hunt_9781401684952_epub_c17_r1",
 			"name" : "Text/Hunt_9781401684952_epub_c17_r1",
 			"component" : TEXTHUNT_9781401684952_EPUB_C17_R1
 		},
 		{
 			"path" : "/Text/Hunt_9781401684952_epub_c65_r1",
 			"name" : "Text/Hunt_9781401684952_epub_c65_r1",
 			"component" : TEXTHUNT_9781401684952_EPUB_C65_R1
 		},
 		{
 			"path" : "/Text/Hunt_9781401684952_epub_c52_r1",
 			"name" : "Text/Hunt_9781401684952_epub_c52_r1",
 			"component" : TEXTHUNT_9781401684952_EPUB_C52_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js